import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Box } from "@mui/material";
import Logo from "../../assets/logo.svg";
import RedButton from "../buttons/redButton";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { login } from "../../redux/reducer";
import supabase from "../../supabase";
import { clearCurrentEmployeeCache } from "../../utils/currentEmployee";

const loginSchema = Yup.object().shape({
  email: Yup.string()
    .email("Email inválido")
    .required("El usuario es requerido"),
  password: Yup.string().required("La contraseña es requerida"),
});

const LoginForm = ({
  handleSubmit,
  isSubmitting,
  values,
  errors,
  authError,
}) => (
  <Form className="form_container">
    <div className="flex">
      <h4>Usuario</h4>
      <Field type="text" className="input" name="email" />
      <ErrorMessage className="error_message" name="email" component="h5" />

      <h4>Contraseña</h4>
      <Field type="password" className="input" name="password" />
      <ErrorMessage className="error_message" name="password" component="h5" />

      {authError && <h5 className="error_message">{authError}</h5>}

      <div className="button_container">
        <RedButton
          title="Ingresar"
          type="submit"
          disabled={
            isSubmitting ||
            !values.email ||
            !values.password ||
            errors.email ||
            errors.password
          }
        />
      </div>
    </div>
  </Form>
);

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [authError, setAuthError] = useState("");

  const handleSubmit = async (values) => {
    try {
      const { data: authData, error: authError } =
        await supabase.auth.signInWithPassword({
          email: values.email,
          password: values.password,
        });

      if (authError) {
        setAuthError("Las credenciales son inválidas");
        return;
      }

      const { data: employeeData, error: employeeError } = await supabase
        .from("employees")
        .select("name, lastName")
        .eq("uid", authData.user.id)
        .single();

      if (employeeError) {
        setAuthError("Error al obtener datos del empleado");
        return;
      }

      const username = `${employeeData.name} ${employeeData.lastName}`;
      localStorage.setItem("username", username);
      // Por si se entra con otro usuario sin haber cerrado sesión antes.
      clearCurrentEmployeeCache();

      const adminUsers = process.env.REACT_APP_ADMIN_USER?.split(',').map(e => e.trim()) || [];
      const isAdmin = adminUsers.includes(values.email.trim());

      dispatch(
        login({
          isAdmin: isAdmin,
          username,
        })
      );

     navigate(isAdmin ? "/admin" : "/");
    } catch (error) {
      setAuthError("Error en el inicio de sesión");
    }
  };

  return (
    <div className="login_container">
      <Box className="logo_container">
        <img className="logo" src={Logo} alt="support-it logo" />
      </Box>
      <Formik
        initialValues={{ email: "", password: "" }}
        validationSchema={loginSchema}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting, values, errors }) => (
          <LoginForm
            handleSubmit={handleSubmit}
            isSubmitting={isSubmitting}
            values={values}
            errors={errors}
            authError={authError}
          />
        )}
      </Formik>
    </div>
  );
};

export default Login;
